// extracted by mini-css-extract-plugin
export default {"statusCard":"VacancyInsights_statusCard__v58cE"};